/** Product name. Change it here only. */
export const APP_NAME = "Dueable";

/** Shown as plain text, not a mailto link, so it's harder for spam bots to collect (Mike, 2026-10-13). */
export const PRIVACY_EMAIL = "dataprivacy@techminded.xyz";

/** Session flag: Settings → Delete my account sets it; the landing page shows "deleted" once. */
export const ACCOUNT_DELETED_KEY = "dueable.accountDeleted";
